module.exports = "mutation UpdateCategoriesOrder($categories:[UpdateCategoryOrderInput]!){updateCategoriesOrder(categories:$categories){success}}"